import { fetchHandler } from "../Handler/Handler";

export const DashboardAPI = async (slugname) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/dashboard`,
            data: null
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const DashboardChartsAPI = async (slugname) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/piechart`,
            data: null
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};